import { RuntimeLoadedFontConfigVO } from './../../../textfield/RuntimeLoadedFontConfigVO';
import {EnvGlobalsHandler} from "../../EnvGlobalsHandler";
import {IEnvironmentGlobals} from "../../IEnvironmentGlobals";
import {getLogger} from "@goodgamestudios/logger";
import {TEXT_FIELDS_LOGGER} from "../../../../../index";
const logger = getLogger(TEXT_FIELDS_LOGGER + ".BasicFontData");
export abstract class BasicFontData {
    protected _runtimeLoadedFontsConfigurations: RuntimeLoadedFontConfigVO[];

    constructor() {
        this.initialize();
    }

    private initialize(): void {
        this.initializeRuntimeLoadedFontConfigurations();
    }

    protected abstract initializeRuntimeLoadedFontConfigurations(): void ;

    public /*final*/ get runtimeLoadedFontsConfigurations(): RuntimeLoadedFontConfigVO[] {
        return this._runtimeLoadedFontsConfigurations;
    }

    /**
     * Composes the default font name for the current language of a specific game
     * @param ggsLanguageCode: Pass Country::ggsLanguageCode
     * @return
     */
    public /*final*/ getFontNameByGGSLanguageCode(ggsLanguageCode: string = ""): string {
        return this.env.gameTitle + "Fonts";
    }

    public /*final*/ currentLanguageRequiresRuntimeLoadedFont(ggsLanguageCode: string = ""): boolean {
        logger.debug("currentLanguageRequiresRuntimeLoadedFont for ", ggsLanguageCode);
        return this.isRuntimeLoadedFont(this.getFontNameByGGSLanguageCode(ggsLanguageCode)); // GGSCountryController.instance.currentCountry.
    }

    /**
     * Returns true if the given font name is in the list of the fonts that have to be loaded at runtime depending on
     * the language. This list is defined in the IEnvironmentGlobals::languagesRequiringRuntimeLoadedFonts property.
     *
     * @param fontName: Pass a valid composed name provided by getFontNameByGGSLanguageCode()
     * @return
     */
    public /*final*/ isRuntimeLoadedFont(fontName: string = ""): boolean {
        //TODO HTML5 no longer has runtime fonts, need to load each one over HTTP
        if (fontName === "") {
            logger.warn("isRuntimeLoadedFont::  Why is fontname EMPTY?? ");
            return false;
        }
        for (let runtimeLoadedVO of this._runtimeLoadedFontsConfigurations) {
            if (fontName == runtimeLoadedVO.fontName) {
                return true;
            }
        }

        return false;
    }

    private get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }
}

